import Utils from "@/common/util.js";
export default [
  {
    path: "/futures",
    name: "tradingContest",
		redirect: '/futures/trading-contest',
		component: () => import('@/layout/index'),
    children: [
      {
        name: 'trading-contest',
        path: 'trading-contest',
        component: () => {
          const {startTime, endTime} = JSON.parse(sessionStorage.getItem('activity_time'))
          let flag = Utils.countDownTime(startTime, endTime)
          if (flag.noStart){
            return import('@/pages/v2/newTradingContest/index')
          } else if(flag.active) {
            return import('@/pages/v2/newTradingContest/activityStart')
          } else if (flag.end){
            return import('@/pages/v2/newTradingContest/activeEndList')
          } else {
            return import('@/pages/v2/newTradingContest/index')
          }
        }
      },
      {
        path: 'trading-contest/awards-records',
        component: () => import('@/pages/v2/newTradingContest/awardsList')
      },
      // {
      //   path: 'trading-contest/activity-end',
      //   component: () => import('@/pages/v2/newTradingContest/activeEndList')
      // },
      {
        path: 'trading-contest/activity-rules',
        component: () => import('@/pages/v2/newTradingContest/activityRules')
      },
      {
        path: 'trading-contest/my-star',
        component: () => import('@/pages/v2/newTradingContest/myStar')
      },
      // {
      //   path: 'trading-contest/activity-start',
      //   component: () => import('@/pages/v2/newTradingContest/activityStart')
      // }
      
      
    ],
  }
];



// WEBPACK FOOTER //
// ./src/router/v2/newTradingContest/index.js